import { render, staticRenderFns } from "./Type4Form.vue?vue&type=template&id=b97249b8&scoped=true&"
import script from "./Type4Form.vue?vue&type=script&lang=js&"
export * from "./Type4Form.vue?vue&type=script&lang=js&"
import style0 from "./Type4Form.vue?vue&type=style&index=0&id=b97249b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97249b8",
  null
  
)

export default component.exports